import * as CryptoJS from "crypto-js";
import Cookies from "js-cookie";
const key = process.env.REACT_APP_PUBLICKEY;

export const encodeData = (name, value, options = {}) => {
  try {
    const encryptedValue = CryptoJS.AES.encrypt(value.toString(), key);
    Cookies.set(name, encryptedValue, options);
  } catch (error) {
    return error;
  }
};

export const decodedData = (name) => {
  try {
    const encryptedValue = Cookies.get(name);
    if (!encryptedValue) return null;
    const decodedData = CryptoJS.AES.decrypt(encryptedValue, key);
    return decodedData.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    return error;
  }
};
